import { z } from 'zod';

export const AbbreviatedDispatchPriorities = z.enum(['P1', 'P2', 'P3']);

export type AbbreviatedDispatchPriority = z.infer<
  typeof AbbreviatedDispatchPriorities
>;
